<template>
    <span
        :uk-tooltip="
            disabled
                ? 'title:' +
                  $t('x.module.disabled.hint', {x: $t('clickandbuy')})
                : ''
        "
        :class="disabled ? 'module-disabled-struct' : ''">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <div class="uk-text-right uk-margin-medium-bottom">
                <ToggleItem :toggle="'target: #' + modalIdApi">
                    <Button is-round mode="primary">
                        <Translate translation-key="order.stats.api" />
                    </Button>
                </ToggleItem>
            </div>
            <Modal is-round :id="modalIdApi" :title="$t('order.stats.api')">
                <div>
                    <Translate translation-key="order.stats.api.description" />
                </div>

                <div class="uk-margin-small-top">
                    GET {{ apiUrl }}/lunacart/orders
                </div>
                <div>Header: token</div>

                <div class="uk-margin-medium-top" />

                <InfoBox
                    icon="warning"
                    class="uk-margin-medium-bottom"
                    mode="warning"
                    v-if="clickAndBuySettings.orderApiTokens">
                    <Translate translation-key="regenerate.token.description" />
                </InfoBox>

                <Button
                    :is-loading="tokenLoading"
                    :is-disabled="token !== null"
                    has-action
                    :action="actionToken"
                    is-round
                    mode="theme"
                    is-max
                    is-large>
                    <Translate
                        v-if="clickAndBuySettings.orderApiTokens"
                        translation-key="regenerate.token" />
                    <Translate v-else translation-key="generate.token" />
                </Button>

                <div v-if="token" class="uk-margin-top">
                    <TextField
                        is-round
                        icon="code"
                        classes="cursor-pointer"
                        name="lunacart-order-api-token"
                        label="token"
                        :tooltip="$t('copy.to.clipboard')"
                        :value="token"
                        :on-click="codeToClipboard"
                        :action-function="codeToClipboard"
                        action-icon="copy-clipboard"
                        :action-tooltip="$t('copy.to.clipboard')" />
                </div>
            </Modal>

            <div v-if="stats">
                <div
                    class="uk-grid uk-child-width-expand@m uk-child-width-1-2@s uk-child-width-1-1 uk-text-center uk-grid-match"
                    uk-grid>
                    <div>
                        <Card is-round is-dark mode="default">
                            <div class="overview-title">
                                <Translate
                                    translation-key="revenue.last.x.days"
                                    :parameter="{x: 3}" />
                            </div>
                            <div class="overview-value">
                                {{
                                    getNumberWithCurrency(
                                        stats.revenueLast3Days
                                    )
                                }}
                            </div>
                        </Card>
                    </div>
                    <div>
                        <Card is-round is-dark mode="default">
                            <div class="overview-title">
                                <Translate
                                    translation-key="orders.last.x.days"
                                    :parameter="{x: 3}" />
                            </div>
                            <div class="overview-value">
                                {{ stats.ordersLast3Days }}
                            </div>
                        </Card>
                    </div>
                    <div>
                        <Card is-round is-dark mode="default">
                            <div class="overview-title">
                                <Translate translation-key="total.revenue" />
                            </div>
                            <div class="overview-value">
                                {{ getNumberWithCurrency(stats.totalRevenue) }}
                            </div>
                        </Card>
                    </div>
                    <div>
                        <Card is-round is-dark mode="default">
                            <div class="overview-title">
                                <Translate translation-key="total.orders" />
                            </div>
                            <div class="overview-value">
                                {{ stats.totalOrders }}
                            </div>
                        </Card>
                    </div>
                </div>

                <div v-if="stats.showcaseChart" class="uk-margin-large-top">
                    <div ref="showcaseChart" class="chart-container" />
                </div>

                <template v-if="stats.fundraising">
                    <hr class="uk-margin-medium-top uk-margin-medium-bottom" />
                    <div
                        class="uk-grid uk-child-width-expand uk-text-center uk-margin-medium-bottom"
                        uk-grid>
                        <div v-if="stats.fundraising.totalGoal != null">
                            <Card is-round is-dark mode="default">
                                <div class="overview-title">
                                    <Translate
                                        translation-key="fundraising.total.goal" />
                                </div>
                                <div class="overview-value">
                                    {{
                                        getNumberWithCurrency(
                                            stats.fundraising.totalGoal
                                        )
                                    }}
                                </div>
                            </Card>
                        </div>
                        <div>
                            <Card is-round is-dark mode="default">
                                <div class="overview-title">
                                    <Translate
                                        translation-key="fundraising.total.raised" />
                                </div>
                                <div class="overview-value">
                                    {{
                                        getNumberWithCurrency(
                                            stats.fundraising.totalRaised
                                        )
                                    }}
                                </div>
                            </Card>
                        </div>
                        <div v-if="stats.fundraising.progressPercent != null">
                            <Card is-round is-dark mode="default">
                                <div class="overview-title">
                                    <Translate
                                        translation-key="fundraising.progress" />
                                </div>
                                <div class="overview-value">
                                    {{
                                        getNumberWithCurrency(
                                            stats.fundraising.progressPercent,
                                            false,
                                            true
                                        )
                                    }}
                                    %
                                </div>
                            </Card>
                        </div>
                    </div>

                    <div class="uk-margin-top">
                        <div ref="fundraisingChart" class="chart-container" />
                    </div>
                </template>
            </div>
            <div v-else>
                <div uk-spinner />
            </div>
        </span>
    </span>
</template>

<script>
import Highcharts from 'highcharts';
import Translate from '@/components/Translate.vue';
import Card from '@/components/generic/Card.vue';
import axios from 'axios';
import Button from '@/components/generic/Button.vue';
import Modal from '@/components/generic/Modal.vue';
import ToggleItem from '@/components/generic/ToggleItem.vue';
import TextField from '@/components/generic/TextField.vue';
import InfoBox from '@/components/generic/InfoBox.vue';
import UIkit from 'uikit';

export default {
    name: 'LunaStatsAdmin',
    components: {
        InfoBox,
        TextField,
        ToggleItem,
        Modal,
        Button,
        Card,
        Translate,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clickAndBuySettings: {
            type: Object,
        },
    },
    data() {
        return {
            stats: null,
            showcaseChartInstance: null,
            fundraisingChartInstance: null,
            modalIdApi: 'modal-api-stats',

            tokenLoading: false,
            token: null,
        };
    },

    async mounted() {
        await this.loadStats();
    },

    beforeDestroy() {
        this.showcaseChartInstance?.destroy();
        this.fundraisingChartInstance?.destroy();
    },

    methods: {
        codeToClipboard() {
            this.copyToClipboard(this.token);

            UIkit.notification({
                message: this.$t('copied.to.clipboard', {
                    description: this.$t('link'),
                }),
                status: 'info',
                pos: 'top-center',
                timeout: 5000,
            });
        },
        actionToken() {
            this.tokenLoading = true;
            let http = axios.create();
            http.post(this.apiUrl + '/manage-clickandbuys/order-api-token')
                .then((response) => {
                    this.tokenLoading = false;
                    this.token = response.data.token;
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.tokenLoading = false;
                });
        },
        async loadStats() {
            try {
                const http = axios.create();
                const res = await http.get(
                    this.apiUrl + '/manage-clickandbuys/stats'
                );
                this.stats = res.data;
                this.translateChartSeries();
                this.$nextTick(() => {
                    this.renderShowcaseChart();
                    if (this.stats.fundraising) {
                        this.renderFundraisingChart();
                    }
                });
            } catch (e) {
                console.error('Failed to load stats', e);
            }
        },
        translateChartSeries() {
            const translateSeries = (series) => {
                if (!series) return;
                series.forEach((s) => {
                    if (s.nameKey) s.name = this.$t(s.nameKey);
                    if (s.data) {
                        s.data.forEach((p) => {
                            if (p.nameKey) p.name = this.$t(p.nameKey);
                        });
                    }
                });
            };
            translateSeries(this.stats.showcaseChart?.series);
            translateSeries(this.stats.fundraising?.chart?.series);
        },

        renderShowcaseChart() {
            if (!this.stats.showcaseChart || !this.$refs.showcaseChart) return;
            const {series} = this.stats.showcaseChart;
            const fmt = (v) => this.getNumberWithCurrency(v);

            this.showcaseChartInstance = Highcharts.chart(
                this.$refs.showcaseChart,
                {
                    chart: {type: 'column'},
                    title: {text: null},
                    xAxis: {type: 'category'},
                    yAxis: {
                        min: 0,
                        title: {text: null},
                        labels: {
                            formatter() {
                                return fmt(this.value);
                            },
                        },
                    },
                    legend: {enabled: false},
                    tooltip: {
                        headerFormat:
                            '<span style="font-size:11px">{series.name}</span><br>',
                        formatter() {
                            return (
                                '<span style="color:' +
                                this.point.color +
                                '">' +
                                this.point.name +
                                '</span>: <b>' +
                                fmt(this.y) +
                                '</b>'
                            );
                        },
                    },
                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: true,
                                formatter() {
                                    return fmt(this.y);
                                },
                            },
                        },
                    },
                    series,
                    credits: {enabled: false},
                }
            );
        },

        renderFundraisingChart() {
            if (!this.stats.fundraising?.chart || !this.$refs.fundraisingChart)
                return;
            const {categories, series} = this.stats.fundraising.chart;
            const hasGoal = this.stats.fundraising.totalGoal != null;
            const fmt = (v) => this.getNumberWithCurrency(v);

            this.fundraisingChartInstance = Highcharts.chart(
                this.$refs.fundraisingChart,
                {
                    chart: {type: 'column'},
                    title: {text: null},
                    xAxis: {categories},
                    yAxis: {
                        min: 0,
                        title: {text: null},
                        labels: {
                            formatter() {
                                return fmt(this.value);
                            },
                        },
                    },
                    legend: {enabled: hasGoal},
                    tooltip: {
                        shared: true,
                        formatter() {
                            const cat =
                                this.points[0].series.chart.xAxis[0].categories[
                                    this.x
                                ];
                            let goal = null;
                            let raised = null;
                            this.points.forEach((p) => {
                                if (p.series.userOptions.nameKey === 'goal')
                                    goal = p.y;
                                if (p.series.userOptions.nameKey === 'raised')
                                    raised = p.y;
                            });
                            const progress =
                                goal && goal > 0 && raised !== null
                                    ? ' (' +
                                      Math.round((raised / goal) * 100) +
                                      ' %)'
                                    : '';
                            return this.points.reduce((s, p) => {
                                const suffix =
                                    p.series.userOptions.nameKey === 'raised'
                                        ? progress
                                        : '';
                                return (
                                    s +
                                    '<span style="color:' +
                                    p.color +
                                    '">\u25CF</span> ' +
                                    p.series.name +
                                    ': <span style="font-weight:500">' +
                                    fmt(p.y) +
                                    suffix +
                                    '</span><br/>'
                                );
                            }, '<b>' + cat + '</b><br/>');
                        },
                    },
                    plotOptions: {
                        column: {
                            grouping: false,
                            shadow: false,
                            borderWidth: 0,
                        },
                    },
                    series,
                    credits: {enabled: false},
                }
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.overview-title {
    font-size: 15px;
}
.overview-value {
    font-size: 22px;
    font-weight: 500;
    margin-top: 4px;
}
.chart-container {
    width: 100%;
    min-height: 300px;
}
</style>
